var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticStyle: { "margin-left": "-25px", "margin-top": "-20px" } },
    [
      _c("h2", { staticClass: "page-title-bar" }, [
        _c("i", { staticClass: "ico ico-system" }),
        _vm._v(_vm._s(_vm.$t("PDA Settings")) + " ")
      ]),
      _c(
        "v-tabs",
        {
          staticClass: "mt-6 custom-tabs",
          attrs: { "background-color": "#001e38", color: "#fff", grow: "" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("v-tab", { attrs: { href: "#esl" } }, [
            _vm._v(_vm._s(_vm.$t("ESL PACKAGE")))
          ]),
          _c("v-tab", { attrs: { href: "#qr" } }, [
            _vm._v(_vm._s(_vm.$t("GENERATE QR")))
          ])
        ],
        1
      ),
      _c(
        "v-tabs-items",
        {
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c(
            "v-tab-item",
            { staticClass: "ml-5", attrs: { value: "esl" } },
            [
              _vm._l(_vm.visibleFunctionGroups, function(group) {
                return _c(
                  "div",
                  { key: group.key },
                  [
                    _c(
                      "v-row",
                      [
                        _c("v-col", { attrs: { cols: "12" } }, [
                          _c("h3", { staticClass: "group-title" }, [
                            _vm._v(_vm._s(group.title))
                          ])
                        ])
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      { attrs: { dense: "" } },
                      _vm._l(group.items, function(item, i) {
                        return _c(
                          "v-col",
                          {
                            key: i,
                            staticStyle: { padding: "4px" },
                            attrs: { cols: "6", sm: "4", md: "4", lg: "2" }
                          },
                          [
                            _c(
                              "v-card",
                              {
                                staticClass:
                                  "function-card d-flex align-center pa-6 text-center elevation-4",
                                class: {
                                  selected: item.state,
                                  unselected: !item.state
                                },
                                attrs: { outlined: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.toggleSelect(group.key, i)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "icon-container" },
                                  [
                                    item.state
                                      ? _c(
                                          "v-icon",
                                          { attrs: { color: "#001E38" } },
                                          [_vm._v("mdi-check-circle")]
                                        )
                                      : _c("v-icon", [
                                          _vm._v("mdi-radiobox-blank")
                                        ])
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "card-content" }, [
                                  _c("div", [
                                    _c("img", {
                                      staticClass: "custom-icon",
                                      class: {
                                        "mt-2 ml-0":
                                          item.name === "VISION_ASSIGN"
                                      },
                                      style: {
                                        width:
                                          item.name === "VISION_ASSIGN"
                                            ? "50px"
                                            : "70px"
                                      },
                                      attrs: {
                                        src: require("@/assets/icons/" +
                                          item.svg),
                                        alt: item.label
                                      }
                                    })
                                  ]),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "text-caption",
                                      staticStyle: { "font-weight": "600" }
                                    },
                                    [_vm._v(_vm._s(item.label))]
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              }),
              _c(
                "v-row",
                { staticClass: "mt-8" },
                [
                  _c(
                    "v-col",
                    { staticClass: "text-left", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn",
                          attrs: {
                            disabled: _vm.PDAButtonConfigSave,
                            text: ""
                          },
                          on: { click: _vm.PDAConfigSave }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("Save")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          ),
          _c(
            "v-tab-item",
            { attrs: { value: "qr" } },
            [
              _c(
                "v-row",
                { staticClass: "mt-6 ml-2 mr-4", attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "5" } },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "qr-form-card pa-6",
                          attrs: { elevation: "2" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "qr-form-header mb-5" },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-2",
                                  attrs: { color: "#001E38" }
                                },
                                [_vm._v("mdi-qrcode-plus")]
                              ),
                              _c("span", { staticClass: "qr-form-title" }, [
                                _vm._v(_vm._s(_vm.$t("QR Configuration")))
                              ])
                            ],
                            1
                          ),
                          _c("v-divider", { staticClass: "mb-5" }),
                          _c("v-select", {
                            staticClass: "form-input rowPerPage mb-1",
                            attrs: {
                              items: _vm.storeList,
                              "item-text": "code",
                              "return-object": "",
                              placeholder: _vm.$t("Select Facility"),
                              label: _vm.$t("Facility *"),
                              dense: "",
                              "persistent-hint": "",
                              outlined: "",
                              "hide-details": "",
                              "prepend-inner-icon": "mdi-store"
                            },
                            model: {
                              value: _vm.facility,
                              callback: function($$v) {
                                _vm.facility = $$v
                              },
                              expression: "facility"
                            }
                          }),
                          _c("v-text-field", {
                            staticClass: "form-input mt-4",
                            attrs: {
                              "persistent-placeholder": "",
                              placeholder: _vm.$t("Input User Name"),
                              label: _vm.$t("User Name *"),
                              outlined: "",
                              "hide-details": "",
                              dense: "",
                              clearable: "",
                              "prepend-inner-icon": "mdi-account-outline"
                            },
                            model: {
                              value: _vm.username,
                              callback: function($$v) {
                                _vm.username = $$v
                              },
                              expression: "username"
                            }
                          }),
                          _c("v-text-field", {
                            staticClass: "form-input mt-4",
                            attrs: {
                              "persistent-placeholder": "",
                              placeholder: _vm.$t("Input Password"),
                              label: _vm.$t("Password *"),
                              outlined: "",
                              "hide-details": "",
                              dense: "",
                              clearable: "",
                              "prepend-inner-icon": "mdi-lock-outline",
                              type: "password"
                            },
                            model: {
                              value: _vm.password,
                              callback: function($$v) {
                                _vm.password = $$v
                              },
                              expression: "password"
                            }
                          }),
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn qr-generate-btn mt-6",
                              attrs: {
                                block: "",
                                disabled: _vm.PDAButtonConfigSave
                              },
                              on: { click: _vm.handleGenerateQr }
                            },
                            [
                              _c("v-icon", { attrs: { left: "", small: "" } }, [
                                _vm._v("mdi-qrcode-scan")
                              ]),
                              _vm._v(" " + _vm._s(_vm.$t("Generate QR")) + " ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "pl-md-6 pt-6 pt-md-0",
                      attrs: { cols: "12", md: "5" }
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "qr-preview-card pa-6",
                          attrs: { elevation: "2" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "qr-form-header mb-5" },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-2",
                                  attrs: { color: "#001E38" }
                                },
                                [_vm._v("mdi-qrcode")]
                              ),
                              _c("span", { staticClass: "qr-form-title" }, [
                                _vm._v(_vm._s(_vm.$t("QR Preview")))
                              ])
                            ],
                            1
                          ),
                          _c("v-divider", { staticClass: "mb-5" }),
                          _c(
                            "div",
                            { staticClass: "qr-preview-area" },
                            [
                              _vm.encodedImage
                                ? [
                                    _c("img", {
                                      staticClass: "qr-image",
                                      attrs: {
                                        src: _vm.encodedImage,
                                        alt: "QR Code"
                                      }
                                    })
                                  ]
                                : [
                                    _c(
                                      "div",
                                      { staticClass: "qr-empty-state" },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: { size: "72", color: "#ccc" }
                                          },
                                          [_vm._v("mdi-qrcode")]
                                        ),
                                        _c(
                                          "p",
                                          { staticClass: "qr-empty-text mt-3" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "Fill in the form and click Generate QR to preview"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }